import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import Events from 'constants/Events';
import Constants from 'constants/Constants';

import OrderSettingsStore from 'stores/OrderSettingsStore';

import OrderAction from 'actions/OrderAction';

import DateUtils from 'PMT/utils/DateUtils';


const DEFAULT_MANUFACTURE_DELAY_VALUE = -1;

let timer = null;

import { OrderSettings } from 'PMT/entities/order';

class OrderManufactureDelaySettingsView extends Component {

  static propTypes = {
    orderSettings: PropTypes.objectOf(OrderSettings),
  };

  state = {
    isLoadingManufactureDelay: false,

    newManufactureDelay: this.props.orderSettings.manufactureDelay
  };

  componentWillReceiveProps(nextProps: Object) {
    let newManufactureDelay = this.state.newManufactureDelay;

    if (this.props.orderSettings.manufactureDelay !== nextProps.orderSettings.manufactureDelay) {
      newManufactureDelay = nextProps.orderSettings.manufactureDelay;
    }

    this.setState({
      isLoadingManufactureDelay: false,

      newManufactureDelay
    });
  }

  //
  // getters
  //

  getManufactureDelayAsMinutes(): number {
    // manufactureDelay is store as milliseconds. we need minutes
    return DateUtils.millisecondsToMinutes(this.state.newManufactureDelay);
  }

  //
  // actions
  //

  sendNewManufactureDelay = () => {
    this.setState({
      isLoadingManufactureDelay: true
    });

    const orderSettings: OrderSettings = this.props.orderSettings;
    orderSettings.manufactureDelay = this.state.newManufactureDelay;
    OrderAction.updateOrderSettings(orderSettings);
  };

  changeManufactureDelay(newManufactureDelay: number) {
    this.setState({
      newManufactureDelay
    });

    clearTimeout(timer);
    timer = setTimeout(
      this.sendNewManufactureDelay,
      Constants.Order.DELAY_SEND_NEW_MANUFACTURE_DELAY
    );
  }

  //
  // events
  //

  onMinus = () => {
    let manufactureDelay = this.state.newManufactureDelay;

    manufactureDelay -= DateUtils.MINUTE_AS_MILLISECONDS * 5;

    if (manufactureDelay < 0) {
      manufactureDelay = 0;
    }

    this.changeManufactureDelay(manufactureDelay);
  };

  onPlus = () => {
    let manufactureDelay = this.state.newManufactureDelay;

    manufactureDelay += DateUtils.MINUTE_AS_MILLISECONDS * 5;

    const manufactureDelayAsMinutes = DateUtils.millisecondsToMinutes(manufactureDelay);

    if (manufactureDelayAsMinutes > Constants.Order.MAX_MANUFACTURE_DELAY) {
      manufactureDelay = DateUtils.MINUTE_AS_MILLISECONDS * Constants.Order.MAX_MANUFACTURE_DELAY;
    }

    this.changeManufactureDelay(manufactureDelay);
  };

  //
  // Renderers
  //

  renderSpinnerManufactureDelay() {
    return (
      <div className="order_manufacture_delay_settings__spinner">
        <i className="fa fa-spinner fa-spin" />
      </div>
    );
  }

  renderManufactureDelaySettings() {
    return (
      <div className="order_manufacture_delay_settings__action_block">
        <h3>{I18n.tr('order.manufacture_delay.label')}</h3>
        <div
          className="order_manufacture_delay_settings__minus"
          onClick={this.onMinus}
        >
          <i className="fa fa-minus" />
        </div>
        <div className="order_manufacture_delay_settings__value">
          {this.getManufactureDelayAsMinutes()} min
        </div>
        <div
          className="order_manufacture_delay_settings__plus"
          onClick={this.onPlus}
        >
          <i className="fa fa-plus" />
        </div>
      </div>
    );
  }

  render() {
    try {
    let contentView = (null);

    if (_.isNull(this.props.orderSettings)) {
      contentView = (null);
    } else if (this.state.isLoadingManufactureDelay) {
      contentView = this.renderSpinnerManufactureDelay();
    } else {
      contentView = this.renderManufactureDelaySettings();
    }

    return (
      <div className="order_manufacture_delay_settings">
        {contentView}
      </div>
    );
  } catch (e) { console.error(e); }
  }

}

export default OrderManufactureDelaySettingsView;



// WEBPACK FOOTER //
// ./scripts/pages/order/ordersList/orderManufactureDelay/OrderManufactureDelaySettingsView.js